module.exports = __webpack_public_path__ + "img/bakcground.0161689a.png";